import { render, staticRenderFns } from "./ResponsiveDesktop.vue?vue&type=template&id=d4316074"
import script from "./ResponsiveDesktop.vue?vue&type=script&lang=js"
export * from "./ResponsiveDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports